module.exports = __webpack_public_path__ + "c3b7cf35d514815f3606bbd830c2d0ba.svg";